<template>
  <div class="container">
    <div class="item-container">
      <div class="menu-content">
        <menu-list name="番茄工作法" subName="" :itemIcon="tomatoIcon" @click.native="goPage('tomato')"></menu-list>
        <menu-list name="喝水提醒" :subName="drinkOn" :itemIcon="waterIcon" @click.native="goPage('water')"></menu-list>
        <menu-list name="服药提醒" :subName="cureOn" :itemIcon="pillIcon" @click.native="goPage('pills')"></menu-list>
        <menu-list name="自定义提醒" :subName="customOn" :itemIcon="customIcon" @click.native="checkVersion"></menu-list>
        <!-- list_icon_cy@2x -->
      </div>
      <div class="menu-content mt-10">
        <menu-list name="备注日历名称" subName="" :itemIcon="listIconBz" @click.native="goPage('MondifyName')"></menu-list>
        <menu-list name="购买记录" subName="" :itemIcon="gmjlIcon" @click.native="goPage('buyList')"></menu-list>
        <menu-list name="城市选择" :subName="city" :itemIcon="postionIcon" @click.native="goPage('city')"></menu-list>
       <!--  <menu-list name="留言板" subName="" @click.native="goPage('memo')"></menu-list> -->
        <menu-list name="常见问题" subName="" :itemIcon="questionIcon" @click.native="goPage('question')"></menu-list>
        <menu-list name="关于" subName="" :itemIcon="aboutIcon" @click.native="goPage('about')"></menu-list>
        <menu-list name="更改/设置Wi-Fi" :itemIcon="wifiIcon" subName="" @click.native="checkVersion_WIFI"></menu-list>
      </div>
      <div class="menu-content mt-10">
        <menu-list name="更多设置" :itemIcon="moreSettingIcon" subName="" @click.native="goPage('moreSet')"></menu-list>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import NavBar from '../../components/NavBar/NavBar.vue'
import MenuList from '../../components/MenuList/MenuList.vue'
import {mapMutations} from 'vuex'
import Common from '../../assets/js/common.js'
var api = process.env.BASE_URL
var isLocal = Common.getEvn()
var iconUrl = Common.staticHref()
export default {
  components: {
    NavBar,
    MenuList
  },
  data () {
    return {
      city: '正在获取设备位置',
      drinkOn: '已开启',
      cureOn: '已开启',
      customOn: '已开启',
      locationId: null,
      wifiIcon: iconUrl + 'img/wifis.png',
      aboutIcon: iconUrl + 'img/abouts.png',
      questionIcon: iconUrl + 'img/questions.png',
      postionIcon: iconUrl + 'img/positions.png',
      pillIcon: iconUrl + 'img/pills.png',
      waterIcon: iconUrl + 'img/waters.png',
      customIcon: iconUrl + 'img/list_icon_cy@2x.png',
      tomatoIcon: iconUrl + 'img/tomatos.png',
      listIconBz: iconUrl + 'img/list_icon_bz.png',
      gmjlIcon: iconUrl + 'img/list_icon_gmjl.png',
      moreSettingIcon: iconUrl + 'img/list_icon_setting.png',
      isFirst: true,
      deviceId: localStorage.getItem('max_device_id'),
      retry: 0
    }
  },
  methods: {
    ...mapMutations(['DrinkWarnInfo', 'PillsWarnInfo', 'TomatoWarnInfo']),
    leftClick () {
      this.$router.push({path: '/'})
    },
    checkVersion () {
      // eslint-disable-next-line one-var
      let that = this,
        _url = api + '/Calendar/api/version/get/device/version/info/',
        _deviceId = localStorage.getItem('max_device_id')
      if (isLocal === 'local') {
        _url = '/Calendar/api/version/get/device/version/info/'
      }
      that.toast = that.$createToast({
        time: 0,
        txt: '请稍后',
        mask: true
      }).show()
      axios.post(_url, {
        'device_id': _deviceId
      })
        .then(res => {
          that.toast.hide()
          let _ware = res.data.info.software
          if (!_ware) {
            that.goPage('reminder')
          } else {
            let _infos = _ware.split('_')
            let _mcu = parseInt(_infos[_infos.length - 1])
            let _wifi = _infos[0]
            _wifi = parseInt((_wifi.replace(/./g, '')).slice(-2))
            if (_wifi < 38 || _mcu < 99) {
              that.$createDialog({
                type: 'alert',
                // content: '您的设备软件版本过低(需XX3.8_0099及以上才能设置自定义提醒),请长按日历右键联网升级。'
                content: '内测中，敬请期待...'
              }).show()
            } else {
              // 3.8_0099及以上固件才可以设置自定义提醒
              that.goPage('reminder')
            }
          }
        })
        .catch(reason => {
          if (that.retry === 0) {
            that.retry = 1
            that.checkVersion()
          } else {
            that.toast.hide()
            that.goPage('reminder')
          }
        })
    },
    checkVersion_WIFI () {
      // eslint-disable-next-line one-var
      let that = this,
        _url = api + '/Calendar/api/version/get/device/version/info/',
        _deviceId = localStorage.getItem('max_device_id')
      if (isLocal === 'local') {
        _url = '/Calendar/api/version/get/device/version/info/'
        _deviceId = localStorage.getItem('max_device_id')
      }
      that.toast = that.$createToast({
        time: 0,
        txt: '请稍后',
        mask: true
      }).show()
      axios.post(_url, {
        'device_id': _deviceId
      })
        .then(res => {
          that.toast.hide()
          let _ware = res.data.info.software
          let ini_sw = res.data.info.ini_sw
          // console.log('gs>>>>>>>>>>>>1', res.data)
          // alert(_ware+"{cw }")
          // console.log(_ware)
          // console.log(">>>>>>>>>2",ini_sw);
          if(!ini_sw){
            // console.log(">>>>>>>>>3",ini_sw);
            this.$router.push({path: '/ConfigWiFi63', params: this.max_device_id})
            return ""
          }else if(ini_sw == 'S.0.1.7_0063'){
            this.$router.push({path: '/ConfigWiFi63', params: this.max_device_id})
            return ""
          }
          if (!_ware) {
            this.$router.push({path: '/ConfigWiFi63', params: this.max_device_id})
          } else {
            let _infos = _ware.split('_')
            let _mcu = _infos[1]
            _mcu = parseInt(_mcu)
            if (_mcu > 128) {
              // 0102及以上固件显示Wi-Fi配置提醒
              this.$router.push({path: '/ConfigWiFi120'})
            } else if(_mcu>99) {
              this.$router.push({path: '/ConfigWiFi'})
            }
            else {
              this.$router.push({path: '/ConfigWiFi63'})
            }
          }
        })
        .catch(reason => {
          if (that.retry === 0) {
            that.retry = 1
            that.checkVersion_WIFI()
          } else {
            this.$router.push({path: '/UpgradeVersionInstructions'})
          }
        })
    },
    goPage (e) {
      if (e === 'city') {
        this.$router.push({path: '/CitySelect'})
      } else if (e === 'water') {
        this.$router.push({path: '/DrinkWater'})
      } else if (e === 'pills') {
        this.$router.push({path: '/TakePills', query: {pageName: 'setting'}})
      } else if (e === 'MondifyName') {
        this.$router.push({path: '/ModifyCalendarname'})
      } else if (e === 'buyList') {
        this.$router.push({path: '/BuyList'})
      } else if (e === 'tomato') {
        this.$router.push({path: '/TomatoWork'})
      } else if (e === 'wifi') {
        // this.$router.push({path: '/StepOne', query: {pageName: 'Setting'}})
        this.$router.push({path: '/ConfigWiFi63'})
      } else if (e === 'question') {
        this.$router.push({path: '/Question'})
      } else if (e === 'about') {
        this.$router.push({path: '/About'})
      } else if (e === 'moreSet') {
        this.$router.push({path: '/MoreSetting'})
      } else if (e === 'reminder') {
        this.$router.push({path: '/ReminderList', query: {id: this.deviceId}})
      }
    },
    getWarn () {
      if (isLocal === 'local') {
        axios.get('/Calendar/api/device/get/device/reminder/list?device_id=' + this.deviceId)
        .then(this.getWarnSucess)
        .catch(this.getWarnError)
      } else {
        axios.get(api + '/Calendar/api/device/get/device/reminder/list?device_id=' + this.deviceId)
        .then(this.getWarnSucess)
        .catch(this.getWarnError)
      }
    },
    getWarnSucess (res) {
      this.toast = this.$createToast({
        time: 0,
        txt: '正在获取设置信息',
        mask: true
      }).show()
      const reData = res.data
      if (reData) {
        if (reData.result === 0 && reData.reminder_list && reData.reminder_list.length > 0) {
          reData.reminder_list.forEach((item, index) => {
            if (item.reminder === 1) {
              this.DrinkWarnInfo(item)
              if (item.drink_on) {
                this.drinkOn = '已开启'
              } else {
                this.drinkOn = '已关闭'
              }
            } else if (item.reminder === 2) {
              this.PillsWarnInfo(item)
              if (item.cure_on) {
                this.cureOn = '已开启'
              } else {
                this.cureOn = '已关闭'
              }
            } else if (item.reminder === 3) {
              this.TomatoWarnInfo(item)
            }
          })
        } else {
          console.log(reData.message)
        }
        this.toast.hide()
      }
    },
    getWarnError (error) {
      this.toast.hide()
      console.log(error)
    },
    getLoaction () {
      if (isLocal === 'local') {
        axios.get('/Calendar/api/device/get/device/location/?device_id=' + this.deviceId)
        .then(this.getLoactionSucc)
        .catch(this.getLoactionError)
      } else {
        axios.get(api + '/Calendar/api/device/get/device/location/?device_id=' + this.deviceId)
        .then(this.getLoactionSucc)
        .catch(this.getLoactionError)
      }
    },
    getLoactionSucc (res) {
      let _res = res.data
      if (_res) {
        localStorage.setItem('max_p_name', '根据您的日历定位推荐')
        let _result = _res.result
        if (_result === 0) {
          try {
            let location = _res.location
            if (JSON.stringify(location) !== '{}') {
              if (location.province === location.district) {
                this.city = location.district + '.' + location.city
              } else {
                this.city = location.province + '.' + location.district + '.' + location.city
              }
              if (location.location_id) {
                this.locationId = location.location_id
                localStorage.setItem('max_p_name', '您当前设置的位置是')
              }
              localStorage.setItem('max_city', this.city)
            } else {
              this.city = '地址未知'
              localStorage.setItem('max_city', this.city)
            }
          } catch (error) {
            console.log(error)
          }
        } else {
          console.log(_res.message)
          this.city = '地址未知'
        }
      }
    },
    getLoactionError (error) {
      console.log(error)
    }
  },
  mounted () {
    if (this.deviceId) {
      this.getWarn()
      this.getLoaction()
    }
  },
  activated () {
    Common.setTitle('设置')
    if (this.isFirst) {
      this.isFirst = false
      return false
    } else {
      // console.log('aa')
      this.deviceId = localStorage.getItem('max_device_id')
      localStorage.removeItem('max_city')
      this.getWarn()
      this.getLoaction()
    }
  }
}
</script>
<style lang="stylus" scoped>
.item-container
  height calc(100% - 26px)
  overflow auto
  .menu-content
    padding 0 16px
    background #ffffff
</style>



// WEBPACK FOOTER //
// src/pages/Setting/Setting.vue